// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .AppSpot-module__content--nfw2U {
  width: 100%;
  overflow: hidden;
  min-height: 100vh; 
  display: flex;
  flex-direction: column; 
}

.AppSpot-module__border--XJAse {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
  width: 100%;
  margin-top: 20px;
  flex-shrink: 0; 
}

.AppSpot-module__storeContent--GpnY_ {
  box-sizing: border-box;
  text-align: center;
  margin-top: auto; 
  margin-bottom: auto; 
}

.AppSpot-module__storeContent--GpnY_ h2 {
  color: #0054e6;
  font-size: 26px;
  line-height: 1.2;
  font-weight: 600;
}

.AppSpot-module__storeContent--GpnY_ p {
  color: #767680;
  font-size: 15px;
  line-height: 1.5;
}

.AppSpot-module__storeLinks--cRKZ7 {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/app-page/AppSpot.module.css"],"names":[],"mappings":"CAAC;EACC,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[" .content {\r\n  width: 100%;\r\n  overflow: hidden;\r\n  min-height: 100vh; \r\n  display: flex;\r\n  flex-direction: column; \r\n}\r\n\r\n.border {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding-bottom: 20px;\r\n  width: 100%;\r\n  margin-top: 20px;\r\n  flex-shrink: 0; \r\n}\r\n\r\n.storeContent {\r\n  box-sizing: border-box;\r\n  text-align: center;\r\n  margin-top: auto; \r\n  margin-bottom: auto; \r\n}\r\n\r\n.storeContent h2 {\r\n  color: #0054e6;\r\n  font-size: 26px;\r\n  line-height: 1.2;\r\n  font-weight: 600;\r\n}\r\n\r\n.storeContent p {\r\n  color: #767680;\r\n  font-size: 15px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.storeLinks {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-content: center;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `AppSpot-module__content--nfw2U`,
	"border": `AppSpot-module__border--XJAse`,
	"storeContent": `AppSpot-module__storeContent--GpnY_`,
	"storeLinks": `AppSpot-module__storeLinks--cRKZ7`
};
export default ___CSS_LOADER_EXPORT___;
